import { getHandleId, getTargetHandleStyle } from '@common-services/utils';
import { Handle, Position } from 'reactflow';
import { nodeTypes } from '../bt-nodes-def';
import NodeContainer from '../node-container';
import type { NodeType } from '@common-models/bot-node';
import { memo } from 'react';


type HandleSlot = { id?: string };
type QuestionNodeProps = {
    id: string;
    data: { type?: NodeType; handles?: { inputs?: HandleSlot[]; outputs?: HandleSlot[] } };
};

function QuestionNode({ id, data }: QuestionNodeProps) {
    const type = data?.type

    const nodeColor = type ? nodeTypes?.[type]?.color : undefined



    return (
        <>
            <Handle type="target" position={Position.Left} id={getHandleId(data.handles, 'target', 0) ?? undefined}
                style={{ zIndex: 3, ...getTargetHandleStyle(nodeColor ?? '') }} />
            <NodeContainer type={type} id={id} />
        </>
    )
}

export default memo(QuestionNode);